<template>
  <div class="food-manage">
    <el-form ref="postFrom" :inline="true" class="search-user-form fn-clear">
      <el-form-item label="适用年级" prop="gradeSelectors" class="fn-left">
        <el-checkbox-group v-model="gradeSelectors">
          <el-checkbox v-model="checkAllGrades" @change="handleCheckAllGradeChange">全选</el-checkbox>
          <el-checkbox v-for="(item,index) in gradeLists" :key="'grade' + index" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="店铺" prop="shopSelectors" class="fn-left">
        <el-checkbox-group v-model="shopSelectors">
          <el-checkbox v-model="checkAllShops" @change="handleCheckAllShopChange">全选</el-checkbox>
          <el-checkbox v-for="(item,index) in shopLists" :key="'shop' + index" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item v-if="searchType == 'smallclass'" label="科目" prop="subject_id" class="fn-left">
        <Select key="10044" :selected.sync="postForm.subject_id" :data="subjectLists" clearable placeholder="请选择" />
      </el-form-item>
      <el-form-item label="条件" class="fn-left" prop="timeAry">
        <div>
          <el-date-picker v-model="timeAry" style="width: 300px;" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          时间段内，签到次数大于
          <el-input v-model="postForm.times" style="display: inline-block;width:90px" placeholder="" type="number" />
          人
        </div>

      </el-form-item>
      <el-form-item class="fn-left">
        <el-button type="primary" @click="fnSearchUsers()">查看合适学员</el-button>
      </el-form-item>
    </el-form>
    <div v-if="userIds" class="search-result">
      <el-button style="color: #409EFF;" type="text" @click="handleCopyLink()">[点我复制]</el-button>
      <p class="aui-ellipsis aui-ellipsis-2">{{ userIds }}</p>
    </div>
    <div v-else class="search-result">
      <p>未找到学员，请更换设置条件并点击查看合适学员</p>
    </div>
  </div></template>

<script>

import commondata from '@/utils/commondata'
import Select from '@/components/Select'

const defaultPostForm = {
  gradeId: '',
  shopId: '',
  subject_id: '0',
  sBeginTime: '',
  sEndTime: '',
  times: ''
}

export default {
  name: 'UserSelectSearch',
  components: {
    Select
  },
  props: {
    searchType: {
      type: String,
      default: 'tuolele'
    }
  },
  data() {
    return {
      gradeLists: commondata.GRADE_LISTS,
      subjectLists: [],
      postForm: Object.assign({}, defaultPostForm),
      gradeSelectors: [],
      shopSelectors: [],
      shopLists: [],
      timeAry: '',
      checkAllGrades: false,
      checkAllShops: false,
      userIds: ''
    }
  },
  created() {
    this.fnGetSelectList()
  },
  methods: {
    fnGetSelectList: function() {
      this.$http.getMyShopList().then(res => {
        this.shopLists = res.data
      })
      this.$http.getSmallClassSubject().then(res => {
        this.subjectLists = [{ id: '0', name: '全部' }, ...res.data]
      })
    },
    handleCopyLink() {
      const _this = this
      this.$copyText(this.userIds).then(function(e) {
        _this.$message({
          showClose: true,
          message: '复制成功',
          type: 'success'
        })
      }, function(e) {
        _this.$message({
          showClose: true,
          message: '复制失败，请手动复制',
          type: 'error'
        })
      })
    },
    fnSearchUsers() {
      if (this.gradeSelectors.length == 0) {
        this.$message.error('请选择年级')
        return
      }
      if (this.shopSelectors.length == 0) {
        this.$message.error('请选择班级')
        return
      }
      if (!this.timeAry) {
        this.$message.error('请选择日期')
        return
      }
      if (!this.postForm.times) {
        this.$message.error('请选择日期')
        return
      }
      this.postForm.gradeId = this.gradeSelectors.join(',')
      this.postForm.shopId = this.shopSelectors.join(',')
      if (this.searchType == 'tuolele') {
        this.$http.getConditonSub(this.postForm).then(res => {
          this.userIds = res.data
        })
      } else if (this.searchType == 'smallclass') {
        this.$http.getWeekendConditonSub(this.postForm).then(res => {
          this.userIds = res.data
        })
      }
    },
    changeTime: function(val) {
      if (val != null) {
        this.postForm.sBeginTime = val[0]
        this.postForm.sEndTime = val[1]
      } else {
        this.postForm.sBeginTime = ''
        this.postForm.sEndTime = ''
        this.timeAry = []
      }
    },
    handleCheckAllGradeChange: function() {
      this.checkAllGrades = !this.checkAllGrades
      if (this.checkAllGrades) {
        this.gradeSelectors = this.gradeLists.map(ele => { return ele.id })
      } else {
        this.gradeSelectors = []
      }
    },
    handleCheckAllShopChange: function() {
      this.checkAllShops = !this.checkAllShops
      if (this.checkAllShops) {
        this.shopSelectors = this.shopLists.map(ele => { return ele.id })
      } else {
        this.shopSelectors = []
      }
    }
  }

}
</script>

<style scoped>
.el-checkbox{
  margin-right:10px!important
}
.search-user-form .el-checkbox{
  line-height: 1!important;
}
.search-user-form .el-form-item{
  line-height: 1!important;
  margin-bottom:10px!important
}
.search-result {
  padding: 10px;
  background: #efefef;
}

.aui-ellipsis {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-all;
    white-space: normal !important;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.aui-ellipsis-2 {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-all;
    white-space: normal !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.search-result .el-button {
  margin-left: 0px!important;
}
</style>
